
import { PropertySellerInfo } from "./PropertySellerInfo";
import { PropertyMapCard } from "./PropertyMapCard";
import { SimilarPropertiesSection } from "./SimilarPropertiesSection";
import BuyerPropertyDetail from "@/components/buyer/BuyerPropertyDetail";
import { useBuyer } from "@/contexts/BuyerContext";

type SellerInfo = {
  id: string;
  full_name: string | null;
  business_name: string | null;
  phone_number: string | null;
  email: string | null;
  profile_image_url: string | null;
}

interface PropertyDetailSidebarProps {
  sellerInfo: SellerInfo | null;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  zillowLink: string | null;
  propertyId: string;
  price: number;
  bedrooms: number;
  bathrooms: number;
  propertyType?: string | null;
  isAuthenticated?: boolean;
}

export const PropertyDetailSidebar = ({
  sellerInfo,
  address,
  city,
  state,
  zipCode,
  zillowLink,
  propertyId,
  price,
  bedrooms,
  bathrooms,
  propertyType,
  isAuthenticated = true
}: PropertyDetailSidebarProps) => {
  const { isBuyer } = useBuyer();

  // If this is a buyer viewing the property, show buyer-specific components
  if (isBuyer) {
    const property = {
      id: propertyId,
      price,
      bedrooms,
      bathrooms,
      property_type: propertyType,
      address,
      city,
      state,
      zip_code: zipCode
    };

    return (
      <div className="space-y-6">
        {/* Listing Agent information for buyers */}
        <div data-tour="seller-contact">
        <PropertySellerInfo
          sellerInfo={sellerInfo}
          propertyId={propertyId}
          propertyAddress={`${address}, ${city}, ${state}`}
          listingPrice={price}
          isAuthenticated={isAuthenticated}
          showViewAllListings={!!sellerInfo?.id}
        />
        </div>
        
        {/* Buyer-specific property detail component */}
        <BuyerPropertyDetail property={property} seller={sellerInfo} />
        
        {/* Google Map integration */}
        <PropertyMapCard 
          address={address}
          city={city}
          state={state}
          zipCode={zipCode}
          zillowLink={zillowLink}
          isAuthenticated={isAuthenticated}
        />
        
        {/* Similar properties */}
        <SimilarPropertiesSection 
          currentPropertyId={propertyId}
          city={city}
          price={price}
          bedrooms={bedrooms}
          bathrooms={bathrooms}
          propertyType={propertyType}
        />
      </div>
    );
  }

  // Default seller view
  return (
    <div className="space-y-6">
      {/* Seller information */}
      <PropertySellerInfo sellerInfo={sellerInfo} />
      
      {/* Google Map integration */}
      <PropertyMapCard 
        address={address}
        city={city}
        state={state}
        zipCode={zipCode}
        zillowLink={zillowLink}
        isAuthenticated={isAuthenticated}
      />
      
      {/* Similar properties */}
      <SimilarPropertiesSection 
        currentPropertyId={propertyId}
        city={city}
        price={price}
        bedrooms={bedrooms}
        bathrooms={bathrooms}
        propertyType={propertyType}
      />
    </div>
  );
};
